import { ensureRxStorageInstanceParamsAreCorrect as e } from "rxdb-old2";
import { checkVersion as t } from "../../shared/version-check";
import { RxStorageIndexedDBStatics as n, RX_STORAGE_NAME_INDEXEDDB as r } from "./indexeddb-helpers";
import { createIndexedDBStorageInstance as d } from "./indexeddb-storage-instance";
export * from "./indexeddb-helpers";
export * from "./indexeddb-index-helpers";
export * from "./indexeddb-types";
export * from "./indexeddb-storage-instance";
export * from "./indexeddb-find-by-ids";
export var RxStorageIndexedDB = function () {
  function i(e) {
    this.name = r, this.statics = n, this.indexedDBStates = new Map(), this.settings = e;
  }
  return i.prototype.createStorageInstance = function (n) {
    e(n), t();
    var r = Object.assign({}, this.settings, n.options);
    return d(this, n, r);
  }, i;
}();
export function getRxStorageIndexedDB(e = {}) {
  var t = e.IDBKeyRange ? e.IDBKeyRange : IDBKeyRange,
    n = e.indexedDB ? e.indexedDB : indexedDB,
    r = Object.assign({
      batchSize: 300,
      transactionDurability: "relaxed"
    }, e, {
      IDBKeyRange: t,
      indexedDB: n
    });
  return new RxStorageIndexedDB(r);
}